import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

const SearchProperty = ({
    setCurrentPage,
    setItemOffset,
    setsearchInputValue, placeholder }: any) => {
    const location = useLocation();
    const navigate = useNavigate();

    let timer: NodeJS.Timeout;

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        clearTimeout(timer);
        timer = setTimeout(() => {
            if (value.length >= 3 || value.length === 0) {
                setCurrentPage(1)
                setItemOffset(0);
                navigate(`${location.pathname}?page=1`, { replace: true });
                setsearchInputValue(value);
            }
        }, 1000);
    };
    return (
        <div className='d-flex justify-content-end'>
            <input
                className='form-control form-control-solid border-2 py-2 px-4 border-secondary mw-250px'
                type="text"
                onChange={handleInputChange}
                placeholder={`Search ${placeholder}`}
                title='Type minimum 3 characters'
            />
        </div>
    )
}

export default SearchProperty